export default __webpack_public_path__ + "static/media/hop4.76ed900b.jpg";